import { ErrorMessage, Spinner } from "../../../widgets";
import { FC, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { DetectFace } from "../face/detect-face/DetectFace";
import { IQRScannerProps } from "./IQRScannerProps";
import { PageLinkHelper } from "../../../base/helpers";
import { useScanMutation } from "./services/qrScannerApi";

export const QRScanner: FC<IQRScannerProps> = (props) => {
    const { entity, action, pageLink, title, date, referenceNo, enableFaceRecognition, personGroupId, personId, className } = props
    const { siteId } = useParams()
    const [error, setError] = useState<string>('')
    const [isLoading, setLoading] = useState<boolean>(false)
    const [scan] = useScanMutation()
    const navigate = useNavigate()
    const [isFaceDetected, setIsFaceDetected] = useState<boolean>(false)

    useEffect(() => {
        if (!siteId || !entity || !action || !referenceNo)
            return;

        executeScan()

        // eslint-disable-next-line
    }, [siteId, entity, action, referenceNo])

    const executeScan = () => {
        if (enableFaceRecognition && !isFaceDetected) {
            return;
        }

        if (!siteId || !entity || !action || !referenceNo) {
            setError('QR Scan inputs are incomplete.')
            return;
        }

        setError('')
        setLoading(true)
        scan({ siteId, entity, referenceNo, action, date })
            .unwrap()
            .then((data) => {
                if (data.status === true) {
                    setError('QR Scan completed')
                    if (siteId && pageLink && pageLink.pageId) {
                        navigate(PageLinkHelper.getPageLinkUrl(siteId, pageLink))
                    }
                } else {
                    setError(data.message)
                }
            })
            .catch((err) => {
                setError(error)
            })
            .finally(() => setLoading(false))
    }

    const onFaceDetected = (isDetected: boolean) => {
        setIsFaceDetected(isDetected)
        executeScan()
    }

    if (enableFaceRecognition && !isFaceDetected) {
        return (
            <div className={className} title={title}>
                <DetectFace
                    personGroupId={personGroupId}
                    personId={personId}
                    onDetected={onFaceDetected} />
            </div>
        )
    }

    return (
        <div className={className} title={title}>
            <Spinner show={isLoading} message="Please wait..." />
            <ErrorMessage show={!!error} message={error} />
            {(!isLoading) && <>
                <button type="button"
                    className="btn btn-primary"
                    onClick={executeScan}>
                    Refresh
                </button>
            </>}
        </div>
    )
}